module.exports = __webpack_public_path__ + "static/media/help_business_job_menu.0fc32ab6.jpg";